import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const initialItem = {
  name: '',
  price: '',
  imageUrl: '',
  description: '',
  shipping: '',
  id: Date.now()
};

const ItemForm = props => {
  const [item, setItem] = useState(initialItem);
  let history = useHistory();

  const changeHandler = ev => {
    ev.persist();
    let value = ev.target.value;
    if (ev.target.name === 'price') {
      value = parseInt(value, 10);
    }

    setItem({
      ...item,
      [ev.target.name]: value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    axios.post('https://trinkets-shopping-list.herokuapp.com/items', item).then((res) => {
      props.setItemList(res.data)
      history.push(`/item-list/`);
    });
  };

  return (
    <div>
      <h2>Add New Item</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          onChange={changeHandler}
          placeholder="name"
          value={item.name}
        />
        <div className="baseline" />

        <input
          type="number"
          name="price"
          onChange={changeHandler}
          placeholder="Price"
          value={item.price}
        />
        <div className="baseline" />

        <input
          type="string"
          name="imageUrl"
          onChange={changeHandler}
          placeholder="Image"
          value={item.imageUrl}
        />
        <div className="baseline" />

        <input
          type="string"
          name="description"
          onChange={changeHandler}
          placeholder="Description"
          value={item.description}
        />
        <div className="baseline" />

        <input
          type="string"
          name="shipping"
          onChange={changeHandler}
          placeholder="Shipping"
          value={item.shipping}
        />
        <div className="baseline" />
        <input
          type="number"
          name="id"
          onChange={changeHandler}
          placeholder="ID"
          value={item.id}
        />
        <div className="baseline" />

        <button className="md-button form-button">Add New Item</button>
      </form>
    </div>
  );
};

export default ItemForm;
